import {
    Component,
    OnInit,
    Renderer,
    ChangeDetectorRef,
    ElementRef,
    OnDestroy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { OptionsAdminService } from '../services/options-admin.service';
import { LoadingSpinnerService } from "../services/loading-spinner.service";
import { PageTitleService } from "../services/page-title.service";
import { PagerService } from "../services/pager.service";
import { CurrentUserService } from "../services/current-user.service";
import { BrowserWidthService } from "../services/browser-width.service";
import { HttpResponseService } from '../services/httpresponse-service';
import { FacilityService } from '../services/facility.service';
import { ProductLineService } from '../services/product-line.service';
import { ModelService } from '../services/model.service';
import { ModalDialogService } from '../reusable-components/modal-dialog/modal-dialog.service';

import { MCHAvailableProductLineService } from '../services/mchavailableproductline.service';
import { ToasterService, ToasterConfig } from 'angular2-toaster';

import { Option } from '../model/option';
import { OptionsAdmin } from '../model/options-admin';
import { AdminOptionCategory } from '../model/admin-option-category';
import { PagerInfo } from '../model/pager-info';
import { Facility } from '../model/facility';
import { Category } from '../model/category';
import { Constants } from '../model/constants';
import { CurrentUser } from '../model/current-user';
import { ProductLine } from '../model/product-line';

import { AdminOption } from '../model/admin-option';
import { Subscription } from 'rxjs';
import { MCHAvailableProductLine } from '../model/mchavailableproductline';
import { Model } from '../model/model';

@Component({
    selector: 'my-options-admin',
    template: require('./options-admin.component.html'),
    styles: [require('./options-admin.component.scss')]
})
export class OptionsAdminComponent implements OnInit, OnDestroy {
    private ALLCATEGORIESTEXT = 'All Categories';
    private ALLPRODUCTLINESTEXT = 'All Product Lines';

    userId: string;
    searchTerm: string = '';
    filterPlantsButton: string;
    filterCategoriesButton: string = this.ALLCATEGORIESTEXT;
    filterProductLinesButton: string = this.ALLPRODUCTLINESTEXT;
    homeCatButton: string = 'Home Categories';
    customerCatButton: string = 'Customer Categories';

    chosenPlantId: number = 0;
    plantNumber: number = 0;
    productLineId: number = 0;
    height: number;
    homeCatNumber: number = 0;
    customerCatNumber: number = 0;

    options: Option[];
    pagedOptions: Option[];
    optionsAdmin: OptionsAdmin;
    facilities: Facility[];
    homeCategories: Category[];
    productLines: ProductLine[];
    customerCategories: AdminOptionCategory[];
    currentUser: CurrentUser;
    currentRetailerNumber: string;
    modifiedBy: string;
    currentUserId: number;

    pager: PagerInfo;

    currentPage: number = 1;
    totalPageCount: number = 0;

    displayNoMatches: boolean = false;
    onlyUntouchedOptions: boolean = false;
    showBulkCategoryModal: boolean = false;

    subscription: Subscription = new Subscription();

    // below added for rewrite to change options admin page to BAQ admin
    showbulkOptionChange: boolean = false;
    optionsadminTab: boolean = false;
    productlinesTab: boolean = false;
    modelsTab: boolean = false;

    oasearchText: string;
    oaSearchTextChanged: Subject<string> = new Subject<string>();
    allFacilities: Facility[] = new Array<Facility>();

    plTabFacilities: Facility[];
    mchavailableProductLines: MCHAvailableProductLine[];
    mchAvailableProductLineCache: MCHAvailableProductLine[];
    availableProductLineUpdates: MCHAvailableProductLine[] = new Array<MCHAvailableProductLine>();
    modelExclusionUpdates: Model[] = new Array<Model>();
    productLineCache: ProductLine[] = new Array<ProductLine>();
    modelsList: Model[] = new Array<Model>();
    config: ToasterConfig = new ToasterConfig({
        positionClass: this.browserWidthService.getDisplayMode().width.innerWidth < 769 ? 'toast-bottom-full-width' : 'toast-bottom-right'
    });

	tabObjects = [
		{ tabName: 'ProductLines', tabTitle: 'Available Product Lines', shortTitle: "Product Lines", isDefault: true, sortSequence: 1, isActive: true },
		{ tabName: 'Models', tabTitle: 'Model Exclusions', shortTitle: "Model Exclusions", isDefault: false, sortSequence: 2, isActive: false },
		{ tabName: 'OptionsAdmin', tabTitle: 'Options Admin', shortTitle: "Options Admin", isDefault: false, sortSequence: 3, isActive: false }
	];

    constructor(
        public optionsAdminService: OptionsAdminService,
        public route: ActivatedRoute,
        public router: Router,
        public rd: Renderer,
        public cdr: ChangeDetectorRef,
        public ref: ElementRef,
        public spinner: LoadingSpinnerService,
        public pageTitleService: PageTitleService,
        public pagerService: PagerService,
        public facilityService: FacilityService,
        public currentUserService: CurrentUserService,
        public browserWidthService: BrowserWidthService,
        public httpResponseService: HttpResponseService,
        public toasterService: ToasterService,
        public mchAvailableProductLineService: MCHAvailableProductLineService,
        public productLineService: ProductLineService,
        public modelService: ModelService,
        public modalDialogService: ModalDialogService,
    ) {
        const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
            if (x !== undefined && x !== null) {
                if (x.cmhUserId !== this.userId) {
                    this.userId = x.cmhUserId;
                    this.currentRetailerNumber = x.retailerNumber;
                    this.currentUserId = +x.cmhUserId;
                    this.currentUser = x;
                    this.pageTitleService.pageTitle.next({ title: Constants.CmhConnectionTitle, subTitle: 'Current User ' + this.userId });
                }
            }
        });
        this.subscription.add(currentUserSub);
        const windowResizeSub = Observable.fromEvent(window, 'resize')
            .subscribe(() => {
                this.height = document.getElementById('content-wrapper').scrollHeight + 114;
            });
        this.subscription.add(windowResizeSub);

        const changedAdminOptionSub = this.optionsAdminService.changedAdminOption$.subscribe(x => {
            if (x !== undefined && x !== null) {
                let productLineCode = '';
                let option = x;
                if (this.filterProductLinesButton.indexOf('--') >= 0) {
                    productLineCode = this.filterProductLinesButton.split('--')[1];
                    var plIndex = this.productLines.findIndex(pl => pl.ProductLineCode === productLineCode);
                    if (plIndex !== undefined && plIndex !== -1) {

                        option.AdminOption = new AdminOption();
                        if (option.AdminOptions.length > 0) {
                            if (option.AdminOptions.filter(ao => Number(ao.ProductLineId) === Number(this.productLines[plIndex].ProductLineId)).length > 0) {
                                option.AdminOption = option.AdminOptions.filter(ao => Number(ao.ProductLineId) === Number(this.productLines[plIndex].ProductLineId))[0];
                            }
                        }
                        if (option.AdminOption.CustomerDesc === '') {
                            option.AdminOption.CustomerDesc = option.OptionDescription;
                            option.AdminOption.CustomerBaseDesc = option.OptionDescription;
                        }
                    }
                }

                let options = new Array<Option>();
                options = this.pagedOptions;
                let optionIndex = options.findIndex(o => o.OptionId === x.OptionId);
                if (optionIndex >= 0) {
                    options[optionIndex] = x;
                }
                this.pagedOptions = this.sortOptions(options);
            }
        });
        this.subscription.add(changedAdminOptionSub);

        const reloadOptionsAdminSub = this.optionsAdminService.reloadOptionsAdmin$.subscribe(x => {
            if (x) {
                this.applyFiltersLoadAdminOptions((this.pager === undefined || this.pager === null) ? 1 : this.pager.currentPage);
            }
        });
        this.subscription.add(reloadOptionsAdminSub);

        const uncheckBulkChangeOptionsSub = this.optionsAdminService.uncheckBulkChangeSelectedOptions$.subscribe(x => {
            if (x === true) {
                if (this.options !== undefined) {
                    this.options.filter(o => o.SelectItemForBulkChange === true).forEach(option => { option.SelectItemForBulkChange = false; });
                }
            }
        });
        this.subscription.add(uncheckBulkChangeOptionsSub);

        const oaSearchTextChangeSub = this.oaSearchTextChanged
            .debounceTime(500)              // wait 500ms after the last event before emitting last event
            .distinctUntilChanged()         // only emit if value is different from previous value
            .subscribe(searchText => {
                this.searchTerm = searchText !== undefined && searchText !== null ? searchText: '';
                this.applyFiltersLoadAdminOptions(1);
            });
        this.subscription.add(oaSearchTextChangeSub);

        const facilityListSub = this.facilityService.getFacilitiesForModelsBAQAdmin().subscribe(facs => {
            this.allFacilities = facs;
            this.allFacilities.sort((a, b) => {
                if (a.PlantNumber < b.PlantNumber) {
                    return -1;
                }
                if (a.PlantNumber > b.PlantNumber) {
                    return 1;
                }
                return 0;
            });

        });
        this.subscription.add(facilityListSub);

    }

    ngOnInit() {
        if (this.currentUser !== undefined && this.currentUser !== null
            && this.currentUser.availableFacilities !== undefined && this.currentUser.availableFacilities !== null && this.currentUser.availableFacilities.length > 0) {
            // load facilities from current user's available plants
            this.facilities = new Array<Facility>();
            this.currentUser.availableFacilities.forEach((plant) => {
                let facility = new Facility();
                facility.PlantNumber = Number(plant.plantNumber);
                facility.PlantDescription = plant.name;
                this.facilities.push(facility);
            });
            this.facilities.sort((a, b) => {
                if (a.PlantNumber < b.PlantNumber) {
                    return -1;
                }
                if (a.PlantNumber > b.PlantNumber) {
                    return 1;
                }
                return 0;
            });

        } else {
            this.pager = new PagerInfo();
            this.displayNoMatches = true;
            this.setPage(1, new Array<Option>());
        }

        this.changeTab('ProductLines');
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    /// Reloads the AdminOptions when the retailer is changed
    loadAdminOptions(plant: number, pageNumber: number = 1, productLineCode: string = undefined, categoryId: number = undefined, searchString: string = undefined, showUntouched: boolean = false) {
        this.spinner.showSpinner();
        const optionsAdminSub = this.optionsAdminService.getOptionsByPlantWithPaging(plant, pageNumber, undefined, productLineCode, categoryId, searchString, showUntouched)
            .subscribe(
            (x => {
                if (this.optionsadminTab) {
                    if (x !== undefined && x !== null) {
                        this.pager = new PagerInfo();
                        this.optionsAdmin = x;
                        this.options = x.Options;
                        this.homeCategories = x.Categories;
                        this.productLines = x.ProductLines;
                        this.customerCategories = x.CustomerCategories;
                        this.currentPage = x.CurrentPage;
                        this.totalPageCount = x.TotalPageCount;
                        this.pager.totalPages = x.TotalPageCount;
                        this.pager.currentPage = x.CurrentPage;
                        this.chosenPlantId = plant;

                        this.filterProductLinesButton = this.ALLPRODUCTLINESTEXT;
                        if (productLineCode !== undefined && productLineCode !== null) {
                            var plIndex = this.productLines.findIndex(pl => pl.ProductLineCode === productLineCode);
							if (plIndex !== undefined && plIndex !== -1) {
                                this.filterProductLinesButton = this.productLines[plIndex].ProductLineDescription.trim() + '--' + this.productLines[plIndex].ProductLineCode.trim();

                                this.options.forEach(o => {
                                    o.AdminOption = new AdminOption();
                                    if (o.AdminOptions.length > 0) {
                                        if (o.AdminOptions.filter(ao => Number(ao.ProductLineId) === Number(this.productLines[plIndex].ProductLineId)).length > 0) {
                                            o.AdminOption = o.AdminOptions.filter(ao => Number(ao.ProductLineId) === Number(this.productLines[plIndex].ProductLineId))[0];
                                        }
                                    }
                                    if (o.AdminOption.CustomerDesc === '') {
                                        o.AdminOption.CustomerDesc = o.OptionDescription;
                                        o.AdminOption.CustomerBaseDesc = o.OptionDescription;
                                    }
                                });
                            }
                        }

                        this.filterCategoriesButton = this.ALLCATEGORIESTEXT;
                        if (categoryId !== undefined && categoryId > 0) {
                            var catIndex = this.homeCategories.findIndex(cat => cat.CategoryId === categoryId);
                            if (catIndex !== undefined) {
                                this.filterCategoriesButton = this.homeCategories[catIndex].CategoryDescription.trim();
                            }
                        }

                        this.optionsAdminService.allCustomerCategories$.next(this.customerCategories);
						this.optionsAdminService.plantId$.next(plant);
					}
                }
            }),
            (error => {
                if (this.optionsadminTab) {
                    this.spinner.hideSpinner();
                    this.httpResponseService.httpErrorResponse$.next(error);

                    // clear out existing option data
                    this.pager = new PagerInfo();
                    this.optionsAdmin = new OptionsAdmin();
                    this.options = new Array<Option>();
                    this.homeCategories = new Array<Category>();
                    this.productLines = new Array<ProductLine>();
                    this.customerCategories = new Array<AdminOptionCategory>();
                    this.currentPage = 0;
                    this.totalPageCount = 0;
                    this.pagedOptions = this.options;
                    this.displayNoMatches = true;

                    this.filterCategoriesButton = this.ALLCATEGORIESTEXT;
                    this.filterProductLinesButton = this.ALLPRODUCTLINESTEXT;

                    this.optionsAdminService.allCustomerCategories$.next(this.customerCategories);
                    this.optionsAdminService.plantId$.next(plant);
                }

            }),
            (() => {
                if (this.optionsadminTab) {
                    if (this.optionsAdmin !== undefined && this.optionsAdmin !== null) {
                        this.pagedOptions = this.sortOptions(this.options);
                        this.displayNoMatches = false;
                    } else {
                        this.displayNoMatches = true;
                        this.pagedOptions = new Array<Option>();
                        this.displayNoMatches = true;
                    }
                }
                this.spinner.hideSpinner();
            }));
        this.subscription.add(optionsAdminSub);
        this.optionsAdminService.plantId$.next(plant);

    }

    /// Sorts the Options
    sortOptions(options: Option[]): Option[] {
        if (options !== undefined && options !== null && options.length > 1) {
            return options.sort((a, b) => {
                return a.OptionNumber - b.OptionNumber;
            });
        }
        return options;
    }

    /// Plant is changed
    plantChange(plantNumber: number) {
        if (this.optionsadminTab) {
            this.spinner.showSpinner();
            this.chosenPlantId = plantNumber;
            this.plantNumber = plantNumber;
            this.filterProductLinesButton = this.ALLPRODUCTLINESTEXT;
            this.filterCategoriesButton = this.ALLCATEGORIESTEXT;
            this.filterPlantsButton = this.facilities.find(x => x.PlantNumber === plantNumber).PlantDescription + ' (' + this.facilities.find(x => x.PlantNumber === plantNumber).PlantNumber + ')';
            this.applyFiltersLoadAdminOptions(1);
            this.optionsAdminService.plantId$.next(plantNumber);
            this.showbulkOptionChange = false;
        }
        if (this.productlinesTab) {
            this.plantNumber = plantNumber;
            this.spinner.showSpinner();
            this.filterPlantsButton = this.mchAvailableProductLineCache.find(x => x.PlantNumber === plantNumber).PlantDescription + ' (' + this.mchAvailableProductLineCache.find(x => x.PlantNumber === plantNumber).PlantNumber + ')';
            this.mchavailableProductLines = new Array<MCHAvailableProductLine>();
            this.mchavailableProductLines = this.mchAvailableProductLineCache.filter(fac => fac.PlantNumber === plantNumber);
            this.spinner.hideSpinner();

        }

        if (this.modelsTab) {
            this.spinner.showSpinner();
            this.plantNumber = plantNumber;
            let plantId = 0;

            if (this.allFacilities.findIndex(fac => fac.PlantNumber === plantNumber) !== undefined) {
                plantId = this.allFacilities.find(fac => fac.PlantNumber === plantNumber).PlantId;
            }

            const availableProductLinesSub = this.productLineService.getProductLineByPlant(plantId).subscribe(
                (data => {
                    this.productLineCache = data;

                }),
                (error => {
                    this.spinner.hideSpinner();
                    this.httpResponseService.httpErrorResponse$.next(error);
                }),
                (() => {
                    this.filterPlantsButton = this.allFacilities.find(x => x.PlantNumber === plantNumber).PlantDescription + ' (' + this.allFacilities.find(x => x.PlantNumber === plantNumber).PlantNumber + ')';
                    if (this.productLineCache !== undefined && this.productLineCache !== null) {
                        if (this.productLineCache.length > 0) {
                            let productline = this.productLineCache[0];
                            this.filterProductLinesButton = productline.ProductLineDescription.trim() + '--' + productline.ProductLineCode.trim();;
                            this.modelsList = new Array<Model>();
                            this.modelsList = this.productLineCache.filter(plc => plc.ProductLineId === productline.ProductLineId)[0].Models;
                            this.modelExclusionUpdates = new Array<Model>();
                        }
                    }

                    this.productlinesTab = false;
                    this.modelsTab = true;
                    this.optionsadminTab = false;
                    this.spinner.hideSpinner();

                })
            );
            this.subscription.add(availableProductLinesSub);
            this.modelExclusionUpdates = new Array<Model>();
        }
    }

    /// Selects all Categories
    allCategories() {
        this.spinner.showSpinner();
        this.filterCategoriesButton = this.ALLCATEGORIESTEXT;
        this.applyFiltersLoadAdminOptions(1);
    }

    /// Category is changed
    categoryChange(categoryDesc: string) {
        this.spinner.showSpinner();
        this.filterCategoriesButton = this.homeCategories.find(x => x.CategoryDescription === categoryDesc).CategoryDescription;
        this.applyFiltersLoadAdminOptions(1);
    }

    /// Selects all ProductLines
    allProductLines() {
        this.spinner.showSpinner();
        this.showbulkOptionChange = false;
        this.productLineId = 0;
        this.filterProductLinesButton = this.ALLPRODUCTLINESTEXT;
        this.applyFiltersLoadAdminOptions(1);
    }

    /// ProductLine is changed
    productLineChange(pl: ProductLine) {
        if (this.optionsadminTab) {
            this.spinner.showSpinner();
            this.filterProductLinesButton = pl.ProductLineDescription.trim() + '--' + pl.ProductLineCode.trim();
            if (this.filterProductLinesButton !== this.ALLPRODUCTLINESTEXT) {
                this.showbulkOptionChange = true;
            }
            this.optionsAdminService.selectedProductLineCode$.next(pl.ProductLineCode.trim());
            this.filterCategoriesButton = this.ALLCATEGORIESTEXT;
            this.applyFiltersLoadAdminOptions(1);
        }
        if (this.modelsTab) {
            this.filterProductLinesButton = pl.ProductLineDescription.trim() + '--' + pl.ProductLineCode.trim();;
            this.modelsList = new Array<Model>();
            this.modelsList = this.productLineCache.filter(plc => plc.ProductLineId === pl.ProductLineId)[0].Models;
            this.modelExclusionUpdates = new Array<Model>();
        }
    }    

    /// Resets the pages to a new list of options
    setPage(page: number, options: Option[]) {
        this.spinner.showSpinner();
        if (options !== undefined && options !== null && options.length > 0) {
            this.displayNoMatches = false;
            this.pager = this.pagerService.getPager(this.sortOptions(options), page, 21);
            this.pagedOptions = this.pager.pages[page - 1].Data;
        } else {
            this.displayNoMatches = true;
            this.pager = this.pagerService.getPager(new Array<Option>(), page, 21);
            this.pagedOptions = new Array<Option>();
        }
        this.spinner.hideSpinner();
    }

    /// Navigates to the next page of options
    navigatePages(page: number) {
        this.applyFiltersLoadAdminOptions(page);
    }

    /// Filters Options to only those that have been changed
    updateShowOnlyUntouchedOptions(onlyUntouchedOptions: boolean) {
        this.spinner.showSpinner();
        this.onlyUntouchedOptions = onlyUntouchedOptions;
        this.applyFiltersLoadAdminOptions(1);
    }

    /// Opens the OptionAside
    openAside(item: Option) {
        let productLineCode = null;
        let categoryId = undefined;
        let searchString = undefined;

        if (this.filterProductLinesButton.indexOf('--') >= 0) {
            productLineCode = this.filterProductLinesButton.split('--')[1];
        }
        if (this.filterCategoriesButton.trim() !== this.ALLCATEGORIESTEXT) {
            categoryId = this.homeCategories.find(x => x.CategoryDescription.trim() === this.filterCategoriesButton.trim()).CategoryId !== undefined ? this.homeCategories.find(x => x.CategoryDescription.trim() === this.filterCategoriesButton.trim()).CategoryId : undefined;
        }
        if (this.searchTerm !== undefined && this.searchTerm !== null) {
            if (this.searchTerm.trim().length > 0) {
                searchString = this.searchTerm;
            }
        }

        this.optionsAdminService.openAside(item, this.pagedOptions, this.userId, this.plantNumber, this.currentPage, this.productLineId, productLineCode, categoryId, searchString);
    }

    openBulkChangeAside() {
        var optionList = null;
        if (this.options.filter(o => o.SelectItemForBulkChange === true).length > 0) {
            optionList = this.options.filter(o => o.SelectItemForBulkChange === true);
        }

        this.optionsAdminService.openBulkCategoryChangeAside(this.chosenPlantId, optionList);
    }

    generateProductLineUI(pl: ProductLine, filterProductLinesButton: string): string {
        let desc: string = '';
        if (this.optionsadminTab) {
            if (pl !== undefined && pl != null) {
                if (pl.ProductLineDescription !== undefined && pl.ProductLineDescription !== null && pl.ProductLineDescription !== '') {
                    desc = pl.ProductLineDescription.trim() + '--' + pl.ProductLineCode.trim();
                }
            } else {
                if (filterProductLinesButton !== undefined && filterProductLinesButton !== null && filterProductLinesButton !== '') {
                    let productLineDescription = '';
                    let productLineCode = '';
                    if (filterProductLinesButton.indexOf('--') >= 0) {
                        productLineDescription = filterProductLinesButton.split('--')[0];
                        if (filterProductLinesButton.split('--').length > 1) { productLineCode = filterProductLinesButton.split('--')[1]; }
                    } else {
                        productLineDescription = filterProductLinesButton;
                    }
                    let productLine: ProductLine = this.productLines !== undefined && this.productLines !== null && this.productLines.length > 0
                        ? this.productLines.find(x => x.ProductLineDescription.trim() === productLineDescription && x.ProductLineCode.trim() === productLineCode) : null;
                    if (productLine !== undefined && productLine != null) {
                        if (productLine.ProductLineDescription !== undefined && productLine.ProductLineDescription !== null && productLine.ProductLineDescription !== '') {
                            desc = productLine.ProductLineDescription.trim() + '--' + productLine.ProductLineCode.trim();
                        } else {
                            desc = this.ALLPRODUCTLINESTEXT;
                        }
                    } else {
                        desc = this.ALLPRODUCTLINESTEXT;
                    }
                } else {
                    desc = this.ALLPRODUCTLINESTEXT;
                }
            }
        }

        if (this.modelsTab) {
            if (pl !== undefined && pl != null) {
                if (pl.ProductLineDescription !== undefined && pl.ProductLineDescription !== null && pl.ProductLineDescription !== '') {
                    desc = pl.ProductLineDescription.trim() + '--' + pl.ProductLineCode.trim();
                }
            } else {
                if (filterProductLinesButton !== undefined && filterProductLinesButton !== null && filterProductLinesButton !== '') {
                    let productLineDescription = '';
                    let productLineCode = '';
                    let productLineId = 0;
                    if (filterProductLinesButton.indexOf('--') >= 0) {
                        productLineDescription = filterProductLinesButton.split('--')[0];
                        if (filterProductLinesButton.split('--').length > 1) { productLineCode = filterProductLinesButton.split('--')[1]; }
                    } else {
                        productLineDescription = filterProductLinesButton;
                    }

                    let productLine: ProductLine = this.productLineCache !== undefined && this.productLineCache !== null && this.productLineCache.length > 0
                        ? this.productLineCache.find(x => x.ProductLineCode.trim() === productLineCode.trim() && x.ProductLineDescription.trim() === productLineDescription.trim()) : null;
                    if (productLine !== undefined && productLine != null) {
                        if (productLine.ProductLineDescription !== undefined && productLine.ProductLineDescription !== null && productLine.ProductLineDescription !== '') {
                            desc = productLine.ProductLineDescription.trim() + '--' + productLine.ProductLineCode.trim();
                        } else {
                            desc = '';
                        }
                    } else {
                        desc = '';
                    }
                } else {
                    desc = '';
                }
            }
        }
        return desc;
    }

    getSubOptionCount(item: Option): number {
        if (item !== undefined && item !== null
            && item.SubOptions !== undefined && item.SubOptions !== null && item.SubOptions.length > 0) {
            if (this.productLineId === 0) {
                let suboptions = item.SubOptions.filter(x => x.ProductLineId === item.ProductLineId);
                if (suboptions !== undefined && suboptions !== null && suboptions.length > 0) {
                    return suboptions.length;
                }
            } else {
                let suboptions = item.SubOptions.filter(x => x.ProductLineId === this.productLineId);
                if (suboptions !== undefined && suboptions !== null && suboptions.length > 0) {
                    return suboptions.length;
                }
            }
        }
        return 0;
    }

    applyFiltersLoadAdminOptions(page: number) {
        let productLineCode = undefined;
        let categoryId = undefined;
        let searchString = undefined;
        if (this.filterProductLinesButton.indexOf('--') >= 0) {
            productLineCode = this.filterProductLinesButton.split('--')[1];
        }
        if (this.filterCategoriesButton.trim() !== this.ALLCATEGORIESTEXT) {
            categoryId = this.homeCategories.find(x => x.CategoryDescription.trim() === this.filterCategoriesButton.trim()).CategoryId !== undefined ? this.homeCategories.find(x => x.CategoryDescription.trim() === this.filterCategoriesButton.trim()).CategoryId : undefined;
        }
        if (this.searchTerm !== undefined && this.searchTerm !== null) {
            if (this.searchTerm.trim().length > 0) {
                searchString = this.searchTerm;
            }
        }

        this.loadAdminOptions(this.plantNumber, page, productLineCode, categoryId, searchString, this.onlyUntouchedOptions);

    }

	changeTab(tabName: string) {
		this.tabObjects.forEach(tab => {
			if (tab.tabName === tabName) {
				tab.isActive = true;
			} else {
				tab.isActive = false;
			}
		});

        if (tabName !== undefined && tabName !== null && tabName !== '') {
            if (tabName.toUpperCase() === 'PRODUCTLINES') {
                this.spinner.showSpinner();
                this.productLineCache = new Array<ProductLine>();
                this.mchavailableProductLines = new Array<MCHAvailableProductLine>();
                this.modelsList = new Array<Model>();

                const availableProductLinesSub = this.mchAvailableProductLineService.getMCHAvailableProductLines(true).subscribe(
                    (data => {
                        this.mchAvailableProductLineCache = data;
                        this.plTabFacilities = new Array<Facility>();

                        data.forEach(plant => {
                            let facility = new Facility();
                            facility.PlantNumber = Number(plant.PlantNumber);
                            facility.PlantDescription = plant.PlantDescription;
                            
                            if (this.plTabFacilities.filter(pldd => pldd.PlantNumber === plant.PlantNumber).length === 0) {
                                this.plTabFacilities.push(facility);
                            }

                        });
                    }),
                    (error => {
                        this.spinner.hideSpinner();
                        this.httpResponseService.httpErrorResponse$.next(error);
                    }),
                    (() => {
                        this.mchavailableProductLines = new Array<MCHAvailableProductLine>();

                        if (this.plTabFacilities !== undefined && this.plTabFacilities !== null) {
                            this.plTabFacilities.sort((a, b) => {
                                if (a.PlantNumber < b.PlantNumber) {
                                    return -1;
                                }
                                if (a.PlantNumber > b.PlantNumber) {
                                    return 1;
                                }
                                return 0;
                            });
                            let plantNumber = this.plTabFacilities[0].PlantNumber;
                            this.plantNumber = plantNumber;
                            this.mchavailableProductLines = new Array<MCHAvailableProductLine>();
                            this.mchavailableProductLines = this.mchAvailableProductLineCache.filter(fac => fac.PlantNumber === plantNumber);
                            this.filterPlantsButton = this.plTabFacilities[0].PlantDescription + ' (' + this.plTabFacilities[0].PlantNumber + ')';
                        }

                        this.spinner.hideSpinner();
                        this.productlinesTab = true;
                        this.modelsTab = false;
                        this.optionsadminTab = false;
                    })
                );
                this.subscription.add(availableProductLinesSub);
            }

            if (tabName.toUpperCase() === 'MODELS') {
                this.spinner.showSpinner();
                let plantId = 0;
                let plantNumber = 0;

                if (this.allFacilities.length !== undefined && this.allFacilities.length > 0) {
                    plantNumber = this.allFacilities[0].PlantNumber;
                    plantId = this.allFacilities[0].PlantId;
                    this.filterPlantsButton = this.allFacilities.find(x => x.PlantNumber === plantNumber).PlantDescription + ' (' + this.allFacilities.find(x => x.PlantNumber === plantNumber).PlantNumber + ')';
                }
                this.mchavailableProductLines = new Array<MCHAvailableProductLine>();
                this.modelsList = new Array<Model>();

                const availableProductLinesSub = this.productLineService.getProductLineByPlant(plantId).subscribe(
                    (data => {
                        this.productLineCache = data;

                    }),
                    (error => {
                        this.spinner.hideSpinner();
                        this.httpResponseService.httpErrorResponse$.next(error);
                    }),
                    (() => {
                        if (this.allFacilities.find(x => x.PlantNumber === plantNumber) !== undefined) {
                            this.filterPlantsButton = this.allFacilities.find(x => x.PlantNumber === plantNumber).PlantDescription + ' (' + this.allFacilities.find(x => x.PlantNumber === plantNumber).PlantNumber + ')';
                        } else {
                            this.filterPlantsButton = ''
                        }

                        if (this.productLineCache !== undefined && this.productLineCache !== null) {
                            if (this.productLineCache.length > 0) {
                                let productline = this.productLineCache[0];
                                this.filterProductLinesButton = productline.ProductLineDescription.trim() + '--' + productline.ProductLineCode.trim();;
                                this.modelsList = new Array<Model>();
                                this.modelsList = this.productLineCache.filter(plc => plc.ProductLineId === productline.ProductLineId)[0].Models;
                                this.modelExclusionUpdates = new Array<Model>();
                            }
                        }

                        this.productlinesTab = false;
                        this.modelsTab = true;
                        this.optionsadminTab = false;
                        this.spinner.hideSpinner();

                    })
                );
                this.subscription.add(availableProductLinesSub);

            }

            if (tabName.toUpperCase() === 'OPTIONSADMIN') {
                this.productlinesTab = false;
                this.modelsTab = false;
                this.optionsadminTab = true;

                this.plTabFacilities = new Array<Facility>();
                this.mchavailableProductLines = new Array<MCHAvailableProductLine>();
                this.mchAvailableProductLineCache = new Array<MCHAvailableProductLine>();
                this.availableProductLineUpdates = new Array<MCHAvailableProductLine>();

                this.plantNumber = this.facilities[0].PlantNumber;
                this.filterPlantsButton = this.facilities[0].PlantDescription + ' (' + this.facilities[0].PlantNumber + ')';
				this.filterProductLinesButton = this.ALLPRODUCTLINESTEXT;
				this.filterCategoriesButton = this.ALLCATEGORIESTEXT;

				this.applyFiltersLoadAdminOptions(1);
                this.optionsAdminService.plantId$.next(this.plantNumber);
            }
        }

    }

    searchFor(text: string) {
        this.oaSearchTextChanged.next(text);
    }

    markProductLineAvailableForSave(item: MCHAvailableProductLine) {
        if (this.availableProductLineUpdates === undefined || this.availableProductLineUpdates === null) {
            this.availableProductLineUpdates = new Array<MCHAvailableProductLine>();
        }

        if (this.availableProductLineUpdates.filter(updates => updates.PlantId === item.PlantId && updates.ProductLineCode === item.ProductLineCode).length === 0) {
            let newitem = new MCHAvailableProductLine();
            newitem.PlantNumber = item.PlantNumber;
            newitem.PlantId = item.PlantId;
            newitem.ProductLineCode = item.ProductLineCode;
            newitem.ProductLineCodeDescription = item.ProductLineCodeDescription;
            newitem.BAQAvailable = item.BAQAvailable;

            this.availableProductLineUpdates.push(newitem);
        } else {
            this.availableProductLineUpdates.filter(updates => updates.PlantId === item.PlantId && updates.ProductLineCode === item.ProductLineCode)[0].BAQAvailable = item.BAQAvailable;
        }
    }

    get productLineSaveDisabled(): boolean {
        return (this.availableProductLineUpdates === undefined || this.availableProductLineUpdates === null || this.availableProductLineUpdates.length === 0);
    }

    saveAvailableProductLines() {
        if (this.availableProductLineUpdates.length > 0) {
            this.modalDialogService.getConfirmation({
                headerText: 'Available Product Lines',
                message: 'Plant/Product Line selections will affect availability in Build A Quote. Are you sure?'
            }).subscribe(messageReply => {
                if (messageReply === true) {
                    this.spinner.showSpinner();
                    this.mchAvailableProductLineService.saveAvailableProductLines(this.availableProductLineUpdates).subscribe(
                        (data => {
                            this.mchAvailableProductLineCache = data;
                        }),
                        (error => {
                            this.spinner.hideSpinner();
                            this.httpResponseService.httpErrorResponse$.next(error);
                        }),
                        (() => {
                            this.availableProductLineUpdates = new Array<MCHAvailableProductLine>();
                            this.mchavailableProductLines = new Array<MCHAvailableProductLine>();
                            this.mchavailableProductLines = this.mchAvailableProductLineCache.filter(fac => fac.PlantNumber === this.plantNumber);
                            this.toasterService.pop('success', 'Success!', 'Product line availability has been saved');

                            this.spinner.hideSpinner();
                        })
                    );
                }
            });
        }
    }

    markModelExclusionForSave(item: Model) {
        if (this.modelExclusionUpdates === undefined || this.modelExclusionUpdates === null) {
            this.modelExclusionUpdates = new Array<Model>();
        }

        if (this.modelExclusionUpdates.filter(updates => updates.PlantId === item.PlantId && updates.ProductLineId === item.ProductLineId && updates.ModelId === item.ModelId).length === 0) {
            let newitem = new Model();
            newitem.PlantId = item.PlantId;
            newitem.ModelDescription = item.ModelDescription;
            newitem.ProductLineId = item.ProductLineId;
            newitem.ModelId = item.ModelId;
            newitem.ModelNumber = item.ModelNumber;
            newitem.BAQExcluded = item.BAQExcluded;

            this.modelExclusionUpdates.push(newitem);
        } else {
            this.modelExclusionUpdates.filter(updates => updates.PlantId === item.PlantId && updates.ProductLineId === item.ProductLineId && updates.ModelId === item.ModelId)[0].BAQExcluded = item.BAQExcluded;
        }
    }

    get modelExclusionsSaveDisabled(): boolean {
        return (this.modelExclusionUpdates === undefined || this.modelExclusionUpdates === null || this.modelExclusionUpdates.length === 0);
    }

    saveModelExclusions() {
        if (this.modelExclusionUpdates.length > 0) {
            this.modalDialogService.getConfirmation({
                headerText: 'Model Exclusions',
                message: 'Product Line/Model exclusions will affect availability in Build A Quote. Are you sure?'
            }).subscribe(messageReply => {
                if (messageReply === true) {
                    let productLineId = this.modelExclusionUpdates[0].ProductLineId;

                    this.spinner.showSpinner();
                    this.modelService.saveBAQModelExclusions(this.modelExclusionUpdates).subscribe(
                        (data => {
                            this.productLineCache = data;
                        }),
                        (error => {
                            this.spinner.hideSpinner();
                            this.httpResponseService.httpErrorResponse$.next(error);
                        }),
                        (() => {
                            this.modelsList = this.productLineCache.filter(plc => plc.ProductLineId === productLineId)[0].Models;
                            this.modelExclusionUpdates = new Array<Model>();
                            this.toasterService.pop('success', 'Success!', 'Model exclusions have been saved');

                            this.spinner.hideSpinner();
                        })
                    );
                }
            });
        }
    }

	get isIe() {
		return !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Edge/g);
	}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/options-admin/options-admin.component.ts